import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      nav(u.role === "counselor" ? "/counselor" : "/dashboard");
    } catch (err) {
      setError(formatApiError(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <h1 className="font-serif-display text-4xl mb-2">Admin sign in</h1>
      <p className="mb-8 text-sm" style={{ color: "var(--text-secondary)" }}>
        Admin accounts use a password, separate from the Google/Apple sign-in used everywhere else.
      </p>
      <form onSubmit={submit} className="space-y-4 card-soft p-8">
        <div>
          <label className="label-eyebrow block mb-2">Username or email</label>
          <input data-testid="admin-login-email" type="text" required value={email}
            onChange={e => setEmail(e.target.value)}
            className="w-full rounded-xl border border-[color:var(--border-soft)] px-4 py-3 focus:outline-none focus:border-[color:var(--brand)] focus:ring-2 focus:ring-[color:var(--brand)]/30" />
        </div>
        <div>
          <label className="label-eyebrow block mb-2 flex items-center justify-between">
            <span>Password</span>
            <Link data-testid="forgot-password-link" to="/forgot-password"
              className="normal-case tracking-normal text-[0.7rem] underline"
              style={{ color: "var(--brand)" }}>
              Forgot password?
            </Link>
          </label>
          <input data-testid="admin-login-password" type="password" required value={password}
            onChange={e => setPassword(e.target.value)}
            className="w-full rounded-xl border border-[color:var(--border-soft)] px-4 py-3 focus:outline-none focus:border-[color:var(--brand)] focus:ring-2 focus:ring-[color:var(--brand)]/30" />
        </div>
        {error && <div data-testid="admin-login-error" className="text-sm text-[color:var(--accent)]">{error}</div>}
        <button data-testid="admin-login-submit" type="submit" disabled={busy} className="btn-primary w-full">
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <p className="text-sm text-center" style={{ color: "var(--text-secondary)" }}>
          <Link data-testid="link-back-login" to="/login" className="underline" style={{ color: "var(--brand)" }}>
            Not an admin? Sign in here
          </Link>
        </p>
      </form>
    </div>
  );
}
